import React from 'react';
import { Typography, Stack, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import pricingSheetIcon from '../../images/pricingSheetIcon.svg';
import { I18nKeys } from '../../constants/I18nKeys';

const Title = styled(Typography)({
  maxWidth: '50%',
  textAlign: 'center',
});

export const PricingSheetEmptyLayout: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Stack width="100%" direction="column" spacing="16px" alignItems="center" marginTop="15%">
      <img alt="Empty price sheet" src={pricingSheetIcon} height="125px" />
      <Title fontSize="16px" fontWeight={700}>
        {t(I18nKeys.PricingBaseEmptyTitle)}
      </Title>
      <Title fontSize="14px">{t(I18nKeys.PricingBaseEmptySubtitle)}</Title>
    </Stack>
  );
};
